import type { RefObject } from 'react';
import type { VoiceConnection } from '@wundo/shared/roleplay.ts';
import type { VoiceAgentState } from '@/lib/roleplayCall.ts';
import { useScreenWakeLock } from '@/lib/useScreenWakeLock.ts';
import { PracticeRealtimeCall } from './PracticeRealtimeCall.tsx';

export interface PracticeVoiceCallProps {
  connection: VoiceConnection;
  personaName: string;
  /** Handed the way to hang up, so the screen can go silent the instant End is pressed. */
  hangUpRef: RefObject<(() => Promise<void>) | null>;
  agentState: VoiceAgentState | null;
  captionsVisible: boolean;
  /** What was chosen on the card before the call started. */
  microphoneId: string | null;
  speakerId: string | null;
  /**
   * Whether the user is on their way out. A call that stops on its own is a
   * failure worth saying out loud; the same event on a call somebody just ended
   * is the end of the conversation.
   */
  leaving: boolean;
  onAgentState: (state: VoiceAgentState | null) => void;
  onSuggestEnd: () => void;
  /** The character hung up after its goodbye: end the call as the end button does. */
  onCallEnded: () => void;
  onToggleCaptions: () => void;
}

/**
 * A spoken practice conversation. The screen stays on for the whole call: a
 * laptop dimming mid-sentence is the browser's doing, not the call's.
 */
export function PracticeVoiceCall(props: PracticeVoiceCallProps) {
  useScreenWakeLock(!props.leaving);

  return <PracticeRealtimeCall {...props} />;
}
